import { exportPrcessedOptions } from "../../../lib/constants";
import { unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import Loading from "../../shared/Loading";
import ValueFinder from "../../shared/ValueFinder";

const ExportRow = ({ item }) => {
  return (
    <tr className="bg-glass p-8     ">
      <td className="text-center ">{item?.export_request?.model}</td>
      <td className="text-center align-middle min-w-[120px] ">
        <span>{unixToPersianDay(item?.export_request?.creation_time) ?? "-"}</span> _
        <span>{unixToPersianTime(item?.export_request?.creation_time) ?? "-"}</span>
      </td>
      <td className="text-center">
        <ValueFinder data={exportPrcessedOptions} title={!!item?.export_request?.zip_link_preview} />
      </td>

      <td className="text-center">
        {item?.export_request?.zip_link_preview ? (
          <button
            className="w-full flex-center"
            onClick={() =>
              window.open(
                `${import.meta.env.VITE_STORAGE_ENDPOINT + item?.export_request?.zip_link_preview}`,
                "_blank",
              )
            }
          >
            {/* Uncomment and use the download icon if needed */}
            <img src={"/images/download.svg"} width={40} height={40} alt="search" />
          </button>
        ) : (
          <div className="">
            <Loading />
          </div>
        )}
      </td>
    </tr>
  );
};

export default ExportRow;
